import { memo, useCallback, useEffect, useRef } from 'react'
import { useUserContext } from 'app/services/UserProvider/UserProvider'
import { getUniqueId } from 'lib/util/uniq'
import Body from './components/Body/Body'
import Container from './components/Container/Container'
import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'
import Media from './components/Media/Media'
import Tabs from './components/Tabs/Tabs'
import Wrapper from './components/Wrapper/Wrapper'
import { useModalContext } from './provider/ModalProvider'

/**
 * The `Modal` component
 *
 * @returns {React.ReactElement} the element
 */
function ModalComponent () {
  const {
    isModalActive,
    isModalHidden,
    isModalOpen,
    onAction,
    preventExit,
    setModalRef,
    shouldRender,
    size,
    style
  } = useModalContext()
  const { userActivityStatus } = useUserContext()
  const ariaIdLabel = useRef(`modal-${getUniqueId()}-label`)
  const ref = useRef()

  /**
   * Handle close (via the wrapper)
   */
  const handleClose = useCallback(() => {
    // Dispatch the close action
    onAction('close')
  }, [])

  useEffect(() => {
    setModalRef(ref)
  }, [])

  return (
    <Wrapper
      ref={ref}
      ariaIdLabel={ariaIdLabel.current}
      isOpen={isModalOpen}
      isHidden={isModalHidden}
      isActive={isModalActive}
      onClose={handleClose}
      preventExit={preventExit || !!userActivityStatus}
      shouldRender={shouldRender}
      size={size}
      style={style}
    />
  )
}

// Memoize
const Modal = memo(ModalComponent)

// Bind the types
Modal.Media = Media
Modal.Header = Header
Modal.Body = Body
Modal.Footer = Footer
Modal.Tabs = Tabs
Modal.Container = Container

// Export
export default Modal
